import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '成全影视',
    url: 'https://bjtongshiji.cn',
    description: '成全影视提供高清免费影视在线观看，免费高清电影、电视剧、综艺、动漫等海量资源，免费在线看剧全集流畅追剧。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://bjtongshiji.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '成全影视',
    url: 'https://bjtongshiji.cn',
    description: '高清免费影视在线平台',
    sameAs: [
      'https://weibo.com/chengquan',
      'https://space.bilibili.com/chengquan',
    ],
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <article>
            <HeroSection />
            <FeaturedSection />
            <CategorySection />
            <ArticleSection />
            <FAQSection />
          </article>
        </main>
        <Footer />
      </div>
    </>
  );
}